<template>
  <div class="register-page">
    <!-- 顶部返回 -->
    <div class="back-btn" @click="goBack">
      <svg viewBox="0 0 24 24" class="back-icon">
        <path d="M15 18 L9 12 L15 6" fill="none" stroke="#323233" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- 页面标题（带下划线） -->
    <div class="page-title"><span class="t">注册</span></div>

    <!-- 表单行 -->
    <div class="form-rows">
      <!-- 证件类型（选择） -->
      <div class="form-row" @click="sheetShow = true">
        <svg viewBox="0 0 24 24" class="row-icon" fill="none" stroke="#9AA0A8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2.5" y="4.5" width="19" height="15" rx="2"/>
          <circle cx="8" cy="11" r="2"/>
          <path d="M5 16.5 C5.5 14.8 6.7 14 8 14 C9.3 14 10.5 14.8 11 16.5"/>
          <line x1="14" y1="9.5" x2="18.5" y2="9.5"/>
          <line x1="14" y1="13" x2="18.5" y2="13"/>
        </svg>
        <span :class="['row-text', { placeholder: !certType }]">{{ certType || '点击选择证件类型' }}</span>
      </div>

      <!-- 证件号码 -->
      <div class="form-row">
        <svg viewBox="0 0 24 24" class="row-icon" fill="none" stroke="#9AA0A8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2.5" y="4.5" width="19" height="15" rx="2"/>
          <circle cx="8" cy="11" r="2"/>
          <path d="M5 16.5 C5.5 14.8 6.7 14 8 14 C9.3 14 10.5 14.8 11 16.5"/>
          <line x1="14" y1="9.5" x2="18.5" y2="9.5"/>
          <line x1="14" y1="13" x2="18.5" y2="13"/>
        </svg>
        <input v-model.trim="certNo" class="row-input" type="text" placeholder="请输入证件号码" />
      </div>

      <!-- 姓名 -->
      <div class="form-row">
        <svg viewBox="0 0 24 24" class="row-icon" fill="none" stroke="#9AA0A8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="8" r="3.5"/>
          <path d="M5 19.5 C5.6 15.9 8.5 14 12 14 C15.5 14 18.4 15.9 19 19.5"/>
        </svg>
        <input v-model.trim="name" class="row-input" type="text" placeholder="请输入姓名" />
      </div>

      <!-- 移动电话 -->
      <div class="form-row">
        <svg viewBox="0 0 24 24" class="row-icon" fill="none" stroke="#9AA0A8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/>
          <line x1="10.5" y1="18.5" x2="13.5" y2="18.5"/>
        </svg>
        <input v-model.trim="phone" class="row-input" type="tel" maxlength="11" placeholder="请输入移动电话" />
      </div>

      <!-- 短信验证码 + 获取验证码 -->
      <div class="form-row">
        <svg viewBox="0 0 24 24" class="row-icon" fill="none" stroke="#9AA0A8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2.5 L20 5.5 V11 C20 16.5 16.6 20.2 12 21.5 C7.4 20.2 4 16.5 4 11 V5.5 Z"/>
          <path d="M8.5 11.5 L11 14 L15.5 9.5"/>
        </svg>
        <input v-model.trim="smsCode" class="row-input" type="text" maxlength="6" placeholder="请输入短信验证码" />
        <button :class="['code-btn', { disabled: count > 0 }]" type="button" @click="sendCode">{{ count > 0 ? count + 's后重发' : '获取验证码' }}</button>
      </div>

      <!-- 密码 -->
      <div class="form-row">
        <svg viewBox="0 0 24 24" class="row-icon" fill="none" stroke="#9AA0A8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <rect x="4.5" y="10" width="15" height="10.5" rx="2"/>
          <path d="M8 10 V7.5 C8 5 9.8 3.5 12 3.5 C14.2 3.5 16 5 16 7.5 V10"/>
          <circle cx="12" cy="15" r="1.4" fill="#9AA0A8" stroke="none"/>
        </svg>
        <input v-model="password" class="row-input" type="password" placeholder="密码8-20位，包含大小写字母，数字和符号" />
      </div>

      <!-- 确认密码 -->
      <div class="form-row">
        <svg viewBox="0 0 24 24" class="row-icon" fill="none" stroke="#9AA0A8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <rect x="4.5" y="10" width="15" height="10.5" rx="2"/>
          <path d="M8 10 V7.5 C8 5 9.8 3.5 12 3.5 C14.2 3.5 16 5 16 7.5 V10"/>
          <circle cx="12" cy="15" r="1.4" fill="#9AA0A8" stroke="none"/>
        </svg>
        <input v-model="confirmPwd" class="row-input" type="password" placeholder="请再次输入密码" />
      </div>
    </div>

    <!-- 协议勾选 -->
    <div class="agreement-row" @click="agreed = !agreed">
      <span :class="['checkbox', { checked: agreed }]">
        <svg v-if="agreed" viewBox="0 0 24 24" class="check-icon">
          <path d="M5 12.5 L10 17.5 L19 7" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="agreement-text">
        我已阅读并同意<a class="link-text" @click.stop="onAgreement('用户协议')">《用户协议》</a>、<a class="link-text" @click.stop="onAgreement('隐私协议')">《隐私协议》</a>中的内容
      </span>
    </div>

    <!-- 注册按钮 -->
    <div class="btn-register" @click="doRegister">注册</div>

    <!-- 底部说明 -->
    <div class="notes">
      <div class="note">1.请准确填写本人证件信息，绑定后不可修改。</div>
      <div class="note">2.如您的证件信息或移动电话被其他用户占用，请使用<a class="note-link" @click="onAppeal">《用户申诉》</a>功能解决此问题。</div>
      <div class="note">3.生僻字注册规则：采用该字的半角大写拼音字母加上半角中括号代替，例如 王[JIU]。</div>
    </div>

    <!-- 证件类型选择 -->
    <field-sheet
      :show="sheetShow"
      title="请选择证件类型"
      :options="certTypes"
      :value="certType"
      @select="onCertSelect"
      @close="sheetShow = false"
    />
  </div>
</template>

<script>
import FieldSheet from '@/components/FieldSheet.vue'

export default {
  name: 'Register',
  components: { FieldSheet },
  data() {
    return {
      certType: '',
      certTypes: ['居民身份证', '护照', '港澳居民来往内地通行证', '台湾居民来往大陆通行证', '外国人永久居留身份证'],
      sheetShow: false,
      certNo: '',
      name: '',
      phone: '',
      smsCode: '',
      password: '',
      confirmPwd: '',
      agreed: false,
      count: 0,
      timer: null
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/login')
      }
    },
    onCertSelect(val) {
      this.certType = val
      this.sheetShow = false
    },
    onAgreement(name) {
      this.$router.push(name === '用户协议' ? '/agreement-user' : '/privacy')
    },
    onAppeal() {
      this.$alert('如证件信息或移动电话被占用，请拨打12333或前往线下服务大厅办理用户申诉（演示环境）')
    },
    // 获取验证码：校验手机号后进入60s倒计时（演示环境任意6位数字可通过）
    sendCode() {
      if (this.count > 0) return
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.$alert('请输入正确的移动电话')
        return
      }
      this.$alert('验证码已发送（演示环境请输入任意6位数字）')
      this.count = 60
      this.timer = setInterval(() => {
        this.count -= 1
        if (this.count <= 0) clearInterval(this.timer)
      }, 1000)
    },
    doRegister() {
      if (!this.certType) {
        this.$alert('请选择证件类型')
        return
      }
      if (!this.certNo) {
        this.$alert('请输入证件号码')
        return
      }
      // 居民身份证校验18位（末位可为X）
      if (this.certType === '居民身份证' && !/^\d{17}[\dXx]$/.test(this.certNo)) {
        this.$alert('证件号码格式不正确')
        return
      }
      if (!this.name) {
        this.$alert('请输入姓名')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.$alert('请输入正确的移动电话')
        return
      }
      if (!/^\d{6}$/.test(this.smsCode)) {
        this.$alert('请输入6位短信验证码')
        return
      }
      const pwd = this.password
      if (!pwd || pwd.length < 8 || pwd.length > 20) {
        this.$alert('密码长度为8-20位')
        return
      }
      if (!/[a-z]/.test(pwd) || !/[A-Z]/.test(pwd) || !/\d/.test(pwd) || !/[^A-Za-z0-9]/.test(pwd)) {
        this.$alert('密码需包含大小写字母、数字和符号')
        return
      }
      if (pwd !== this.confirmPwd) {
        this.$alert('两次输入的密码不一致')
        return
      }
      if (!this.agreed) {
        this.$alert('请先阅读并同意《用户协议》、《隐私协议》中的内容')
        return
      }
      // 注册成功：返回登录页（$alert 挂在 body 上，路由跳转后仍展示）
      this.$alert('注册成功，请使用证件号/移动电话和密码登录')
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.register-page {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  /* 顶部淡蓝sky底色，模拟设计稿顶部浅色天空 */
  background: linear-gradient(180deg, #CFE6F6 0%, #E7F2FA 12%, #FFFFFF 28%);
  padding-bottom: calc(60 * var(--w));
}
.back-btn {
  position: absolute;
  left: calc(24 * var(--w));
  top: calc(56 * var(--w));
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.back-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}

/* 标题 + 下划线 */
.page-title {
  margin-top: calc(130 * var(--w));
  padding: 0 calc(72 * var(--w));
}
.page-title .t {
  display: inline-block;
  font-size: calc(52 * var(--w));
  color: #323233;
  padding-bottom: calc(14 * var(--w));
  border-bottom: calc(3 * var(--w)) solid #4A4A4A;
}

/* 表单行 */
.form-rows {
  margin-top: calc(36 * var(--w));
  padding: 0 calc(72 * var(--w));
}
.form-row {
  display: flex;
  align-items: center;
  height: calc(126 * var(--w));
  border-bottom: 1px solid #E8EAEC;
}
.row-icon {
  width: calc(44 * var(--w));
  height: calc(44 * var(--w));
  margin-right: calc(28 * var(--w));
  flex-shrink: 0;
}
.row-text {
  flex: 1;
  min-width: 0;
  font-size: calc(36 * var(--w));
  color: #323233;
  cursor: pointer;
}
.row-text.placeholder {
  color: #C3C8CF;
}
.row-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0;
  font-size: calc(36 * var(--w));
  color: #323233;
  font-family: inherit;
  outline: none;
}
.row-input::placeholder {
  color: #C3C8CF;
}
/* 获取验证码按钮：蓝描边小圆角矩形（对齐设计稿，非胶囊） */
.code-btn {
  flex-shrink: 0;
  height: calc(72 * var(--w));
  padding: 0 calc(34 * var(--w));
  border-radius: calc(12 * var(--w));
  border: 1px solid #2D7DD2;
  background: #fff;
  color: #2D7DD2;
  font-size: calc(32 * var(--w));
  font-family: inherit;
  cursor: pointer;
}
.code-btn.disabled {
  border-color: #C3C8CF;
  color: #9AA0A8;
}

/* 协议勾选 */
.agreement-row {
  margin-top: calc(48 * var(--w));
  padding: 0 calc(72 * var(--w));
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}
.checkbox {
  margin-top: calc(6 * var(--w));
  width: calc(38 * var(--w));
  height: calc(38 * var(--w));
  border: 1px solid #C3C8CF;
  border-radius: calc(8 * var(--w));
  background: #fff;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkbox.checked {
  border-color: #2D7DD2;
  background: #2D7DD2;
}
.check-icon {
  width: calc(26 * var(--w));
  height: calc(26 * var(--w));
}
.agreement-text {
  margin-left: calc(16 * var(--w));
  font-size: calc(30 * var(--w));
  color: #646566;
  line-height: 1.5;
}
.link-text {
  font-size: calc(30 * var(--w));
  color: #2D7DD2;
  cursor: pointer;
}

/* 注册按钮 */
.btn-register {
  margin: calc(72 * var(--w)) calc(72 * var(--w)) 0;
  height: calc(112 * var(--w));
  border-radius: calc(16 * var(--w));
  background: #2D7DD2;
  color: #fff;
  font-size: calc(44 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn-register:active {
  background: #2569B4;
}

/* 底部说明 */
.notes {
  margin: calc(56 * var(--w)) calc(72 * var(--w)) 0;
  font-size: calc(30 * var(--w));
  color: #323233;
  line-height: 1.7;
}
.note-link {
  color: #2D7DD2;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue